/**
 * @flow
 * @format
 */

import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';

// export const actionJumpStep = createRoutine('JUMP_TO_STEP', _.identity, (p, s) => ({ skipAnalytics: s === true }));

// Generate routine actions
const fetchChartData = createRoutine('FETCH_CHART_DATA');
const fetchSchematic = createRoutine('FETCH_SCHEMATIC_DATA');

// Generate regular actions

export const jumpToStep = createAction('JUMP_TO_STEP');
export const scrollToTop = createAction('SCROLL_TO_TOP');

export default {
  jumpToStep,
  scrollToTop,
  fetchChartData,
  fetchSchematic,
};



// WEBPACK FOOTER //
// ./src/routines/global.js